import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iconName", "text", "size", "type"];
import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'emotion-theming';
import { Icon } from "../index";
import { DEFAULT_SIZE_PROP, DEFAULT_TYPE_PROP, VALID_SIZE_PROPS, VALID_TYPE_PROPS } from "./constants";
import BadgeFrame from "./BadgeFrame/";
import BadgeText from "./BadgeText/";
import { getBadgeFrameProps, getBadgeIconMarginPropByBadgeSize } from "./helpers";
var Badge = withTheme(function (_ref) {
  var iconName = _ref.iconName,
      text = _ref.text,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? DEFAULT_SIZE_PROP : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? DEFAULT_TYPE_PROP : _ref$type,
      customStyles = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(BadgeFrame, _extends({}, getBadgeFrameProps({
    size: size,
    type: type
  }), customStyles), iconName && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    size: 16,
    m: getBadgeIconMarginPropByBadgeSize(size)
  }), /*#__PURE__*/React.createElement(BadgeText, null, text));
});
Badge.propTypes = {
  text: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  size: PropTypes.oneOf(VALID_SIZE_PROPS),
  type: PropTypes.oneOf(VALID_TYPE_PROPS)
};
export default Badge;